import { ListAlt } from '@mui/icons-material'
import ProfessionalSectionList from './ProfessionalSectionList'
import ProfessionalSectionCreate from './ProfessionalSectionCreate'
import ProfessionalSectionEdit from './ProfessionalSectionEdit'

const professionalSectionsIndex = {
  icon: ListAlt,
  list: ProfessionalSectionList,
  edit: ProfessionalSectionEdit,
  create: ProfessionalSectionCreate,
}

export default professionalSectionsIndex
